import { render, staticRenderFns } from "./ServerLogs.vue?vue&type=template&id=8129cda0&scoped=true&lang=html"
import script from "./ServerLogs.vue?vue&type=script&lang=js"
export * from "./ServerLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8129cda0",
  null
  
)

export default component.exports